import { render, staticRenderFns } from "./LanguageImport.vue?vue&type=template&id=3cfaa25a&"
import script from "./LanguageImport.vue?vue&type=script&lang=ts&"
export * from "./LanguageImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports